import { Stack, Typography } from '@mui/material'

import { PhxIcon } from '@salsita-ai/platform-project-sdk/ui'

export const PowderCoatingWarning = () => (
  <Stack direction="row" justifyContent="space-between" sx={{ gap: 1 }}>
    <PhxIcon name="WarningCircleDuotone" />
    <Typography variant="body2" color="warning">
      Powder Coating requires an additional leadtime which may take up to 30 days extra.
    </Typography>
  </Stack>
)
